import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
    {
        path: '/jobs',
        name: 'jobsRoot',
        redirect: { name: 'jobs' },
        component: () => import('@/views/Jobs/Index.vue'),
        meta: {
            title: 'jobs.menuTitle',
            menuRendered: true,
            menuTitle: 'jobs.menuTitle',
            permission: 'jobs',
            requiresAuth: true,
            icon: 'mdi-inbox-multiple'
        },
        children: [
            {
                path: '',
                name: 'jobs',
                component: () => import('@/views/Jobs/Jobs/Index.vue'),
                meta: {
                    title: 'jobs.pageTitle',
                    requiresAuth: true,
                    permission: 'jobs'
                }
            },
            {
                path: '/jobs/:jobId',
                name: 'jobsJob',
                component: () => import('@/views/Jobs/Job/Index.vue'),
                meta: {
                    title: 'jobs.details.pageTitle',
                    requiresAuth: true,
                    permission: 'jobs'
                }
            },
            {
                path: '/jobs/:jobId/shipping-orders/:shippingOrderId',
                name: 'jobsJobShipmentsOrder',
                component: () => import('@/views/Shipments/ShipmentsOrders/ShipmentsOrder/Index.vue'),
                meta: {
                    title: 'shippingOrders.details.pageTitle',
                    requiresAuth: true,
                    permission: 'shipping_orders',
                    parentName: 'jobsJob'
                }
            }
        ]
    }
]

export default routes
